export default __webpack_public_path__ + "static/woman-a76014eba8b8d4364dc99260f2885242.png";